import React from "react";
import { HelpCircle, Users, Award } from "lucide-react";

const FAQs = () => {
  return (
    <div className="flex flex-col gap-3 h-full w-full px-1 py-[40px] bg-white rounded-lg container-sm">
      <span className="text-3xl font-bold text-center text-green-800">Frequently asked questions</span>
      <span className="text-lg text-center text-gray-600 max-w-2xl mx-auto">
        Everything you need to know about IFJ.
      </span>
      <div className="flex flex-wrap gap-6 w-full items-center justify-center my-8">
        <section className="question max-w-[405px] flex flex-col gap-4 items-center justify-center bg-gradient-to-br from-green-50 to-white p-6 rounded-xl border border-green-100 hover:shadow-lg transition-all duration-300">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
            <HelpCircle className="w-8 h-8 text-green-600" />
          </div>
          <span className="font-semibold text-lg text-green-800 text-center">Who is eligible to apply for internships through IFJ?</span>
          <p className="text-gray-600 text-center leading-relaxed">
            IFJ is open to students, recent graduates, and young professionals
            looking to gain hands-on experience in their fields. We welcome
            applicants from all industries and backgrounds with a passion for
            growth and learning.
          </p>
        </section>
        <section className="question max-w-[405px] flex flex-col gap-4 items-center justify-center bg-gradient-to-br from-yellow-50 to-white p-6 rounded-xl border border-yellow-100 hover:shadow-lg transition-all duration-300">
          <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center">
            <Users className="w-8 h-8 text-yellow-600" />
          </div>
          <span className="font-semibold text-lg text-yellow-700 text-center">How does the application process work?</span>
          <p className="text-gray-600 text-center leading-relaxed">
            IFJ is open to students, recent graduates, and young professionals
            looking to gain hands-on experience in their fields. We welcome
            applicants from all industries and backgrounds with a passion for
            growth and learning.
          </p>
        </section>
        <section className="question max-w-[405px] flex flex-col gap-4 items-center justify-center bg-gradient-to-br from-green-50 to-white p-6 rounded-xl border border-green-100 hover:shadow-lg transition-all duration-300">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
            <Award className="w-8 h-8 text-green-600" />
          </div>
          <span className="font-semibold text-lg text-green-800 text-center">What support do interns receive?</span>
          <p className="text-gray-600 text-center leading-relaxed">
            IFJ is open to students, recent graduates, and young professionals
            looking to gain hands-on experience in their fields. We welcome
            applicants from all industries and backgrounds with a passion for
            growth and learning.
          </p>
        </section>
      </div>
      <div className="flex flex-col gap-4 items-center justify-center bg-gradient-to-br from-green-50 via-yellow-50 to-green-50 py-8 px-6 rounded-xl my-6 border border-green-100">
        <div className="flex -space-x-2">
          <div className="w-12 h-12 bg-green-500 rounded-full border-2 border-white flex items-center justify-center">
            <Users className="w-6 h-6 text-white" />
          </div>
          <div className="w-12 h-12 bg-yellow-500 rounded-full border-2 border-white flex items-center justify-center">
            <HelpCircle className="w-6 h-6 text-white" />
          </div>
          <div className="w-12 h-12 bg-green-600 rounded-full border-2 border-white flex items-center justify-center">
            <Award className="w-6 h-6 text-white" />
          </div>
        </div>
        <span className="font-bold text-xl text-green-800">Still have questions?</span>
        <span className="text-center text-gray-600 max-w-md">
          Can't find the answer you're looking for? Please reach out to our
          friendly team.
        </span>
        <button className="bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white font-semibold py-3 px-8 rounded-lg transition-all duration-300 hover:shadow-lg transform hover:scale-105">
          Get In Touch
        </button>
      </div>
    </div>
  );
};

export default FAQs;